export const CustomerCommunicationValues = {
  Email: 'email',
  Phone: 'phone_number',
  Both: 'both',
  None: 'none',
} as const;
